import { roleNames } from '@/constants/role-names';
import { api } from '@/redux/api';
import { RootState } from '@/redux/store';

export const selectIsPlatformAdmin = (state: RootState): boolean => {
  const { data: user } = api.endpoints.getUser.select()(state);
  const isPlatformAdmin = user?.role.roleName === roleNames.platformAdmin;
  return isPlatformAdmin;
};
